import { useEffect } from 'react';
import { useSuspenseQueries } from '@tanstack/react-query';

import { getHsptlzFormEntryRedirect, getHsptlzFormPatientInfo } from '../api';

export const useGetHsptlzFormEntryData = (params) => {
  const [redirect, patientInfo] = useSuspenseQueries({
    queries: [
      {
        queryKey: ['getHsptlzFormEntryRedirect'],
        queryFn: () => getHsptlzFormEntryRedirect(params),
      },
      {
        queryKey: ['getHsptlzFormPatientInfo'],
        queryFn: () => getHsptlzFormPatientInfo(params),
      },
    ],
  });

  return { redirectData: redirect.data.data, patientInfoData: patientInfo.data.data };
};
